import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';

import GlobalConst from '../../../common/global-const';
import {useHttpClient} from '../../../common/hook/http';

import Place1 from "./Place1";
import Place2 from "./Place2";

import Loader from '../../../common/component/Loader/Loader';

import './Place.scss';

const Place = () => {
    const {callAPI} = useHttpClient()
    const params = useParams();
    const location = useLocation();

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [data, setData] = useState()

    useEffect(() => {

        let urlTemp = ''

        if (location.pathname.includes('/entertain/')) {

            urlTemp = `entertainment/reservation/${params.id}`

        } else if (location.pathname.includes('/dine/')) {

            urlTemp = `shop/content/${params.id}`

        } else if (location.pathname.includes('/shop/')) {

            urlTemp = `shop/content/${params.id}`

        }

        document.documentElement.dataset.page = 'place';

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    urlTemp
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    responseData.result['map'] = await callAPI(
                        `${GlobalConst.cdn}maps/floor-${responseData.result.floor.id}.svg?${Date.now()}`
                    );

                    setData(responseData.result)

                }

            } catch (e) {
                console.error(e);
            }
        }

        if (urlTemp !== '') fetchData()

    }, []);

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pagePlace" className={location.pathname.includes('/entertain/') ? 'has-page-footer' : null}>
            {
                data ? (
                    location.pathname.includes('/entertain/') ? (
                        <Place1 data={data}/>
                    ) : (
                        location.pathname.includes('/dine/') || location.pathname.includes('/shop/') ? (
                            <Place2 data={data}/>
                        ) : (
                            <></>
                        )
                    )
                ) : (
                    <div className="py-5 my-5">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </div>
                )
            }
        </div>
    )
}

export default Place;